import { render, staticRenderFns } from "./LockUnlockForm.vue?vue&type=template&id=b23f0f60&scoped=true"
import script from "./LockUnlockForm.vue?vue&type=script&lang=js"
export * from "./LockUnlockForm.vue?vue&type=script&lang=js"
import style0 from "./LockUnlockForm.vue?vue&type=style&index=0&id=b23f0f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23f0f60",
  null
  
)

export default component.exports